import api, { handleResponse, handleError } from './api';

/** heyportal.app/i/{code} — the invite landing's one call. */
const inviteService = {
  /** Your own link — `{ code, url }`, minted on the first ask (INVITE FRIENDS). */
  async mine() {
    try {
      return handleResponse(await api.get('/invites/me'));
    } catch (error) {
      return handleError(error);
    }
  },
  /** A club's link — the same `/i/{code}` landing, for its share sheet. Members only (403 otherwise). */
  async forClub(clubId) {
    try {
      return handleResponse(await api.get(`/invites/clubs/${clubId}/invite-link`));
    } catch (error) {
      return handleError(error);
    }
  },
  async describe(code) {
    try {
      return handleResponse(await api.get(`/invites/${encodeURIComponent(code)}`));
    } catch (error) {
      return handleError(error);
    }
  },
};

export default inviteService;
